<div class="container" *ngIf="{ 
    isSigninLoading: isSigninLoading$ | async,
    isSigninError: isSigninError$ | async
 } as data">
    <span *ngIf="data.isSigninLoading" class="wait">{{ 'message.RedirectWait' | translate }}</span>
    <span *ngIf="data.isSigninError" class="error">{{ 'message.SigninError' | translate }}</span>
</div>